<!--<p>
  server-error works!
</p>-->
<div style="text-align: center; font-weight: bold; font-size: 18px;">
  <img src="assets/images/imgError500.jpg" alt="Error 500" style="max-width: 100%; height: auto;">
  <p>500 Internal Server Error</p>
  <p>Oops, something went wrong.</p>
  <p>Try to refresh this page or fell free to contact us if the problem persists.</p>
</div>
